// extracted by mini-css-extract-plugin
export default {"input":"Q7-z","button":"R7-z","selected":"S7-z","unavailable":"T7-z","oos":"U7-z","image":"V7-z","paperCutDisabledOverlay":"W7-z"};